import _ from 'lodash';
import { getLocalStorage } from './storage-cache';

export default function getEditingObjects(storageKey, idName) {
  const storage = getLocalStorage(storageKey) || {};
  const filteredCorrectId = _.pickBy(storage, (v, k) => v[idName] === k);
  return _.values(filteredCorrectId).map(x => ({ ...x, isEditing: true }));
}
